import { Component, HostListener, OnInit } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-applayout',
  imports: [HeaderComponent, SidebarComponent, RouterOutlet, NgClass],
  templateUrl: './applayout.component.html',
  styleUrls: ['./applayout.component.css']
})
export class ApplayoutComponent implements OnInit {

  collapsed = false;
  isMobile = false;

  /** Sur mobile : contrôle l'ouverture de la sidebar en overlay */
  isMobileSidebarOpen = false;

  ngOnInit(): void {
    this.checkMobile();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkMobile();
  }

  private checkMobile(): void {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;

    if (this.isMobile && !wasMobile) {
      this.isMobileSidebarOpen = false;
    }
    if (!this.isMobile && wasMobile) {
      this.isMobileSidebarOpen = false;
    }
  }

  toggleSidebar(): void {
    // Recalcule à chaque clic pour être sûr
    this.isMobile = window.innerWidth <= 768;

    if (this.isMobile) {
      this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
    } else {
      this.collapsed = !this.collapsed;
    }
  }

  closeMobileSidebar(): void {
    this.isMobileSidebarOpen = false;
  }

  handleClickOutside(): void {
    // La ClickOutsideDirective de la sidebar se déclenche aussi quand on clique
    // sur le bouton du header → on ignore sur mobile, le backdrop gère la fermeture
    if (!this.isMobile && this.isMobileSidebarOpen) {
      this.isMobileSidebarOpen = false;
    }
  }

  onOneMenuClicked(): void {
    if (this.isMobile) {
      this.isMobileSidebarOpen = false;
    }
  }
}